"use strict";
/* Generated by ts-generator ver. 0.0.8 */
/* tslint:disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ABI = [
    {
        inputs: [{ internalType: 'bool', name: 'test', type: 'bool' }],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'identifier',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            { indexed: true, internalType: 'address', name: 'issuer', type: 'address' },
        ],
        name: 'AttestationCompleted',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [{ indexed: false, internalType: 'uint256', name: 'value', type: 'uint256' }],
        name: 'AttestationExpiryBlocksSet',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'identifier',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            { indexed: true, internalType: 'address', name: 'issuer', type: 'address' },
            {
                indexed: false,
                internalType: 'address',
                name: 'attestationRequestFeeToken',
                type: 'address',
            },
        ],
        name: 'AttestationIssuerSelected',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'address', name: 'token', type: 'address' },
            { indexed: false, internalType: 'uint256', name: 'value', type: 'uint256' },
        ],
        name: 'AttestationRequestFeeSet',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'identifier',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'attestationsRequested',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'attestationRequestFeeToken',
                type: 'address',
            },
        ],
        name: 'AttestationsRequested',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'identifier',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'fromAccount',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'toAccount',
                type: 'address',
            },
        ],
        name: 'AttestationsTransferred',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [{ indexed: false, internalType: 'uint256', name: 'value', type: 'uint256' }],
        name: 'MaxAttestationsSet',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'registryAddress',
                type: 'address',
            },
        ],
        name: 'RegistrySet',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [{ indexed: false, internalType: 'uint256', name: 'value', type: 'uint256' }],
        name: 'SelectIssuersWaitBlocksSet',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'approver',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'indentifier',
                type: 'bytes32',
            },
            { indexed: false, internalType: 'address', name: 'from', type: 'address' },
            { indexed: false, internalType: 'address', name: 'to', type: 'address' },
            { indexed: false, internalType: 'bool', name: 'approved', type: 'bool' },
        ],
        name: 'TransferApproval',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            { indexed: true, internalType: 'address', name: 'token', type: 'address' },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'Withdrawal',
        type: 'event',
    },
    {
        constant: true,
        inputs: [],
        name: 'attestationExpiryBlocks',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [{ internalType: 'address', name: '', type: 'address' }],
        name: 'attestationRequestFees',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [
            { internalType: 'address', name: 'sender', type: 'address' },
            { internalType: 'bytes', name: 'blsKey', type: 'bytes' },
            { internalType: 'bytes', name: 'blsPop', type: 'bytes' },
        ],
        name: 'checkProofOfPossession',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [
            { internalType: 'uint256', name: 'aNumerator', type: 'uint256' },
            { internalType: 'uint256', name: 'aDenominator', type: 'uint256' },
            { internalType: 'uint256', name: 'bNumerator', type: 'uint256' },
            { internalType: 'uint256', name: 'bDenominator', type: 'uint256' },
            { internalType: 'uint256', name: 'exponent', type: 'uint256' },
            { internalType: 'uint256', name: '_decimals', type: 'uint256' },
        ],
        name: 'fractionMulExp',
        outputs: [
            { internalType: 'uint256', name: '', type: 'uint256' },
            { internalType: 'uint256', name: '', type: 'uint256' },
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [{ internalType: 'bytes', name: 'header', type: 'bytes' }],
        name: 'getBlockNumberFromHeader',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [],
        name: 'getEpochNumber',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [{ internalType: 'uint256', name: 'blockNumber', type: 'uint256' }],
        name: 'getEpochNumberOfBlock',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [],
        name: 'getEpochSize',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [{ internalType: 'uint256', name: 'blockNumber', type: 'uint256' }],
        name: 'getParentSealBitmap',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [{ internalType: 'bytes', name: 'header', type: 'bytes' }],
        name: 'getVerifiedSealBitmapFromHeader',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [{ internalType: 'bytes', name: 'header', type: 'bytes' }],
        name: 'hashHeader',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [],
        name: 'initialized',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [],
        name: 'isOwner',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [],
        name: 'maxAttestations',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [{ internalType: 'uint256', name: 'blockNumber', type: 'uint256' }],
        name: 'minQuorumSize',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [],
        name: 'minQuorumSizeInCurrentSet',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [],
        name: 'numberValidatorsInCurrentSet',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [{ internalType: 'uint256', name: 'blockNumber', type: 'uint256' }],
        name: 'numberValidatorsInSet',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [],
        name: 'owner',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [
            { internalType: 'address', name: '', type: 'address' },
            { internalType: 'address', name: '', type: 'address' },
        ],
        name: 'pendingWithdrawals',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [],
        name: 'registry',
        outputs: [{ internalType: 'contract IRegistry', name: '', type: 'address' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: false,
        inputs: [],
        name: 'renounceOwnership',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        constant: true,
        inputs: [],
        name: 'selectIssuersWaitBlocks',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: false,
        inputs: [{ internalType: 'address', name: 'registryAddress', type: 'address' }],
        name: 'setRegistry',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        constant: true,
        inputs: [
            { internalType: 'address', name: '', type: 'address' },
            { internalType: 'bytes32', name: '', type: 'bytes32' },
        ],
        name: 'transferApprovals',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: false,
        inputs: [{ internalType: 'address', name: 'newOwner', type: 'address' }],
        name: 'transferOwnership',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        constant: true,
        inputs: [{ internalType: 'uint256', name: 'index', type: 'uint256' }],
        name: 'validatorSignerAddressFromCurrentSet',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [
            { internalType: 'uint256', name: 'index', type: 'uint256' },
            { internalType: 'uint256', name: 'blockNumber', type: 'uint256' },
        ],
        name: 'validatorSignerAddressFromSet',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: false,
        inputs: [
            { internalType: 'address', name: 'registryAddress', type: 'address' },
            {
                internalType: 'uint256',
                name: '_attestationExpiryBlocks',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_selectIssuersWaitBlocks',
                type: 'uint256',
            },
            { internalType: 'uint256', name: '_maxAttestations', type: 'uint256' },
            {
                internalType: 'address[]',
                name: 'attestationRequestFeeTokens',
                type: 'address[]',
            },
            {
                internalType: 'uint256[]',
                name: 'attestationRequestFeeValues',
                type: 'uint256[]',
            },
        ],
        name: 'initialize',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        constant: true,
        inputs: [],
        name: 'getVersionNumber',
        outputs: [
            { internalType: 'uint256', name: '', type: 'uint256' },
            { internalType: 'uint256', name: '', type: 'uint256' },
            { internalType: 'uint256', name: '', type: 'uint256' },
            { internalType: 'uint256', name: '', type: 'uint256' },
        ],
        payable: false,
        stateMutability: 'pure',
        type: 'function',
    },
    {
        constant: false,
        inputs: [
            { internalType: 'bytes32', name: 'identifier', type: 'bytes32' },
            { internalType: 'uint256', name: 'attestationsRequested', type: 'uint256' },
            {
                internalType: 'address',
                name: 'attestationRequestFeeToken',
                type: 'address',
            },
        ],
        name: 'request',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        constant: false,
        inputs: [{ internalType: 'bytes32', name: 'identifier', type: 'bytes32' }],
        name: 'selectIssuers',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        constant: false,
        inputs: [
            { internalType: 'bytes32', name: 'identifier', type: 'bytes32' },
            { internalType: 'uint8', name: 'v', type: 'uint8' },
            { internalType: 'bytes32', name: 'r', type: 'bytes32' },
            { internalType: 'bytes32', name: 's', type: 'bytes32' },
        ],
        name: 'complete',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        constant: false,
        inputs: [
            { internalType: 'bytes32', name: 'identifier', type: 'bytes32' },
            { internalType: 'uint256', name: 'index', type: 'uint256' },
        ],
        name: 'revoke',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        constant: false,
        inputs: [{ internalType: 'address', name: 'token', type: 'address' }],
        name: 'withdraw',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        constant: true,
        inputs: [
            { internalType: 'bytes32', name: 'identifier', type: 'bytes32' },
            { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'getUnselectedRequest',
        outputs: [
            { internalType: 'uint32', name: '', type: 'uint32' },
            { internalType: 'uint32', name: '', type: 'uint32' },
            { internalType: 'address', name: '', type: 'address' },
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [
            { internalType: 'bytes32', name: 'identifier', type: 'bytes32' },
            { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'getAttestationIssuers',
        outputs: [{ internalType: 'address[]', name: '', type: 'address[]' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [
            { internalType: 'bytes32', name: 'identifier', type: 'bytes32' },
            { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'getAttestationStats',
        outputs: [
            { internalType: 'uint32', name: '', type: 'uint32' },
            { internalType: 'uint32', name: '', type: 'uint32' },
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [
            {
                internalType: 'bytes32[]',
                name: 'identifiersToLookup',
                type: 'bytes32[]',
            },
        ],
        name: 'batchGetAttestationStats',
        outputs: [
            { internalType: 'uint256[]', name: '', type: 'uint256[]' },
            { internalType: 'address[]', name: '', type: 'address[]' },
            { internalType: 'uint64[]', name: '', type: 'uint64[]' },
            { internalType: 'uint64[]', name: '', type: 'uint64[]' },
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [
            { internalType: 'bytes32', name: 'identifier', type: 'bytes32' },
            { internalType: 'address', name: 'account', type: 'address' },
            { internalType: 'address', name: 'issuer', type: 'address' },
        ],
        name: 'getAttestationState',
        outputs: [
            { internalType: 'uint8', name: '', type: 'uint8' },
            { internalType: 'uint32', name: '', type: 'uint32' },
            { internalType: 'address', name: '', type: 'address' },
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [
            { internalType: 'bytes32', name: 'identifier', type: 'bytes32' },
            { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'getCompletableAttestations',
        outputs: [
            { internalType: 'uint32[]', name: '', type: 'uint32[]' },
            { internalType: 'address[]', name: '', type: 'address[]' },
            { internalType: 'uint256[]', name: '', type: 'uint256[]' },
            { internalType: 'bytes', name: '', type: 'bytes' },
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [{ internalType: 'address', name: 'token', type: 'address' }],
        name: 'getAttestationRequestFee',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: false,
        inputs: [
            { internalType: 'address', name: 'token', type: 'address' },
            { internalType: 'uint256', name: 'fee', type: 'uint256' },
        ],
        name: 'setAttestationRequestFee',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        constant: false,
        inputs: [
            {
                internalType: 'uint256',
                name: '_attestationExpiryBlocks',
                type: 'uint256',
            },
        ],
        name: 'setAttestationExpiryBlocks',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        constant: false,
        inputs: [
            {
                internalType: 'uint256',
                name: '_selectIssuersWaitBlocks',
                type: 'uint256',
            },
        ],
        name: 'setSelectIssuersWaitBlocks',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        constant: false,
        inputs: [{ internalType: 'uint256', name: '_maxAttestations', type: 'uint256' }],
        name: 'setMaxAttestations',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        constant: true,
        inputs: [],
        name: 'getMaxAttestations',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [
            { internalType: 'bytes32', name: 'identifier', type: 'bytes32' },
            { internalType: 'address', name: 'account', type: 'address' },
            { internalType: 'uint8', name: 'v', type: 'uint8' },
            { internalType: 'bytes32', name: 'r', type: 'bytes32' },
            { internalType: 'bytes32', name: 's', type: 'bytes32' },
        ],
        name: 'validateAttestationCode',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [{ internalType: 'bytes32', name: 'identifier', type: 'bytes32' }],
        name: 'lookupAccountsForIdentifier',
        outputs: [{ internalType: 'address[]', name: '', type: 'address[]' }],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [
            { internalType: 'bytes32', name: 'identifier', type: 'bytes32' },
            { internalType: 'address', name: 'account', type: 'address' },
            { internalType: 'uint32', name: 'expected', type: 'uint32' },
        ],
        name: 'requireNAttestationsRequested',
        outputs: [],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: false,
        inputs: [
            { internalType: 'bytes32', name: 'identifier', type: 'bytes32' },
            { internalType: 'uint256', name: 'index', type: 'uint256' },
            { internalType: 'address', name: 'from', type: 'address' },
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'bool', name: 'status', type: 'bool' },
        ],
        name: 'approveTransfer',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
    },
];
function newAttestations(web3, address) {
    return new web3.eth.Contract(exports.ABI, address);
}
exports.newAttestations = newAttestations;
//# sourceMappingURL=Attestations.js.map